import React, { ReactNode } from "react";
import { Menu } from "@mui/material";
import styled from "@emotion/styled";

const StyledMenu = styled(Menu)`
  width: 100%;
`;

interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: (anchorEl: HTMLElement | null) => void;
  children: ReactNode;
}

export const ActionsMenu = ({ anchorEl, setAnchorEl, children }: Props) => {
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <StyledMenu
      className="rangeSelectorMenu"
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      disablePortal
      disableScrollLock
      open={Boolean(anchorEl)}
      onClick={handleCloseMenu}
      onClose={handleCloseMenu}
      slotProps={{
        root: {
          slotProps: {
            backdrop: {
              invisible: true,
              sx: {
                backgroundColor: "transparent !important",
                backdropFilter: "none !important",
              },
            },
          },
        },
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      {children}
    </StyledMenu>
  );
};
